// Usage:
// <element x-data="animate" x-bind="blurUp" />

document.addEventListener('alpine:init', () => {
  Alpine.data('animate', (delay = 0) => ({
    disallowedMobileAnimations: ['slide-in-bottom'],
    isMobile: window.innerWidth <= 640,
    shown: false,
    delay: delay,
    isBot: /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent),
    prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,

    init() {
      // Check if delay has been passed via data prop
      if (this.$el && this.$el.dataset.delay) {
        // Parse delay as integer to ensure correct type
        const parsedDelay = parseInt(this.$el.dataset.delay, 10)
        this.delay = isNaN(parsedDelay) ? 0 : parsedDelay
      }
    },

    blurUp: prepareAnimation('slide-in-blurred-bottom'),
    fadeUp: prepareAnimation('slide-in-bottom'),
    fadeUpSlow: prepareAnimation('slide-in-bottom-slow'),
    fadeIn: prepareAnimation('fade-in'),
    bounceUp: prepareAnimation('bounce-in-bottom'),
    bounceIn: prepareAnimation('bounce-in-fwd'),
    bounceInFromFront: prepareAnimation('bounce-in-bck'),
    bounceInFromRight: prepareAnimation('bounce-in-right')
  }))
})

function prepareAnimation(className) {
  return {
    ['x-intersect.threshold.05.once']() {
      // Check if the animation is disallowed for mobile devices
      if (this.disallowedMobileAnimations.includes(className) && this.isMobile) {
        this.shown = true
        return
      }

      if (this.prefersReducedMotion) {
        this.shown = true
        return
      }

      if (this.delay !== 0) {
        setTimeout(() => {
          this.shown = true
        }, this.delay)
      } else {
        this.shown = true
      }
    },
    // For bots/crawlers, don't hide content
    [':style']: "!shown && !isBot && !prefersReducedMotion && {visibility: 'hidden'}",
    [':class']() {
      if (this.isMobile && this.disallowedMobileAnimations.includes(className)) {
        return ''
      }

      if (this.prefersReducedMotion) {
        return ''
      }

      if (this.shown) {
        return className
      }
    }
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('button', () => ({
    setStyle: function (relY, relX, height, width) {
      this.$refs.span.style.top = relY
      this.$refs.span.style.left = relX
      this.$refs.span.style.height = height
      this.$refs.span.style.width = width
    },
    button: {
      ['@mouseenter'](e) {
        if (window.innerWidth < 640) return

        const parentOffset = this.$el.getBoundingClientRect(),
          relX = e.pageX - (parentOffset.left + window.scrollX),
          relY = e.pageY - (parentOffset.top + window.scrollY),
          width = parentOffset.width * 2.25
        // NB: it is correct to pass the width var to the height parameter
        this.setStyle(relY + 'px', relX + 'px', width + 'px', '225%')
      },
      ['@mouseout'](e) {
        if (window.innerWidth < 640) return

        const parentOffset = this.$el.getBoundingClientRect(),
          relX = e.pageX - (parentOffset.left + window.scrollX),
          relY = e.pageY - (parentOffset.top + window.scrollY)
        this.setStyle(relY + 'px', relX + 'px', '0px', '0px')
      }
    }
  }))
})
